export function snapToBoundary(
  value: number,
  upperBound: number,
  tolerance: number
): number {
  if (Math.abs(value) < tolerance) return 0;
  if (Math.abs(value - upperBound) < tolerance) return upperBound;
  return NaN;
}
